import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(form.email.trim().toLowerCase(), form.password);
      const next = localStorage.getItem("hc_next");
      localStorage.removeItem("hc_next");
      navigate(next || "/");
    } catch (e2) {
      setErr(e2.response?.data?.detail || "Invalid credentials.");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-20 pb-32" data-testid="login-page">
      <div className="font-mono-label text-[10px] text-[var(--accent)] mb-3">ENTER THE BUILDING</div>
      <h1 className="font-display text-5xl uppercase leading-none mb-8">Sign In</h1>
      <form onSubmit={submit} className="space-y-4">
        <input type="email" required placeholder="Email" value={form.email} onChange={(e)=>setForm({...form,email:e.target.value})} className="input-brut" data-testid="login-email" />
        <input type="password" required placeholder="Password" value={form.password} onChange={(e)=>setForm({...form,password:e.target.value})} className="input-brut" data-testid="login-password" />
        {err && <p className="text-[var(--accent)] font-mono-label text-xs" data-testid="login-error">{err}</p>}
        <button type="submit" disabled={busy} className="btn-primary w-full justify-center" data-testid="login-submit">
          {busy ? "Signing in…" : "Sign In"}
        </button>
      </form>
      <div className="mt-4 text-right">
        <Link to="/forgot-password" className="font-mono-label text-[11px] text-neutral-400 hover:text-[var(--accent)]" data-testid="login-forgot-link">
          FORGOT PASSWORD?
        </Link>
      </div>
      <p className="mt-6 font-mono-label text-[11px] text-neutral-400">
        NEW HERE? <Link to="/register" className="text-[var(--accent)] hover:underline">CREATE ACCOUNT</Link>
      </p>
    </div>
  );
}
